import { useId } from "react";
import { cn } from "@/lib/utils";

/**
 * Invora mark: a rounded tile with a stacked "order" glyph (three lines, the
 * last one checked). Drawn inline so it needs no image file and stays crisp.
 */
export function InvoraMark({ className }: { className?: string }) {
  const id = useId();
  return (
    <svg viewBox="0 0 32 32" className={cn("size-7 shrink-0", className)} aria-hidden>
      <defs>
        <linearGradient id={`${id}-g`} x1="0" y1="0" x2="32" y2="32" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="oklch(0.56 0.21 276)" />
          <stop offset="1" stopColor="oklch(0.42 0.19 268)" />
        </linearGradient>
      </defs>
      <rect width="32" height="32" rx="8" fill={`url(#${id}-g)`} />
      <rect x="8" y="8.5" width="16" height="3" rx="1.5" fill="white" />
      <rect x="8" y="14.5" width="11" height="3" rx="1.5" fill="white" opacity="0.75" />
      <path d="M8.6 22.4l2.6 2.4 4.6-5" fill="none" stroke="oklch(0.86 0.13 195)" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

const SIZES = { sm: { mark: "size-6", text: "text-base" }, md: { mark: "size-7", text: "text-lg" }, lg: { mark: "size-9", text: "text-2xl" } } as const;

/** Mark + "Invora" wordmark. */
export function InvoraLogo({ size = "md", className, suffix }: { size?: keyof typeof SIZES; className?: string; suffix?: string }) {
  return (
    <span className={cn("inline-flex items-center gap-2 select-none", className)}>
      <InvoraMark className={SIZES[size].mark} />
      <span className={cn("font-semibold tracking-tight text-foreground", SIZES[size].text)}>Invora</span>
      {suffix && <span className="rounded-md bg-primary/10 px-1.5 py-0.5 text-xs font-medium text-primary">{suffix}</span>}
    </span>
  );
}
